export default function MarketingCampaignSendHeader({
  contactsToSend,
  selectedMarketingCampaign,
  handleOpenSendMarketingCampaignEmail,
}) {
  return (
    <>
      <h1>Envíos</h1>
      <>
        <button
          type="button"
          className={
            contactsToSend.length !== 0 &&
            selectedMarketingCampaign.length !== 0
              ? "subHeader__btn LayoutMarketingCampaigns__button"
              : "subHeader__btn LayoutMarketingCampaigns__button buttonForm--disabled"
          }
          onClick={() => {
            if (
              contactsToSend.length !== 0 &&
              selectedMarketingCampaign.length !== 0
            )
              handleOpenSendMarketingCampaignEmail();
          }}
          disabled={
            contactsToSend.length === 0 ||
            selectedMarketingCampaign.length === 0
          }
        >
          Enviar
        </button>
      </>
    </>
  );
}
